import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonComponent } from '../../@core/components/ui/button/button.component';
import { TextCasePipe } from "../../@shared/pipes/textCase.pipe";
import { AssetUrlPipe } from "../../@shared/pipes/asset-url.pipe";

export enum ErrorType {
    INVALID_URL = 'invalid_url',
}

@Component({
    selector: 'app-page-not-found',
    standalone: true,
    imports: [ButtonComponent, RouterModule, TextCasePipe, AssetUrlPipe],
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent implements OnInit {
    customMessage: string = '';

    constructor(private router: Router, private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const errorType = params['error'] as ErrorType;
            this.customMessage = this.getErrorMessage(errorType);
        });
    }

    private getErrorMessage(errorType: ErrorType): string {
        const errorMessages: Record<ErrorType, string> = {
            [ErrorType.INVALID_URL]: 'The URL is not valid',
        };
        return errorMessages[errorType] || '';
    }

    goToLogin() {
        this.router.navigate(['/login']);
    }
}
